import { registerPlugin } from '@capacitor/core';

export interface StickerSegmenterPlugin {
  // Returns the cut-out subject as raw base64 PNG (alpha), or { subject: false }
  // when Vision finds no foreground subject. Rejects on decode/segmentation error.
  removeBackground(options: { imageBase64: string }): Promise<{ cutoutBase64?: string; subject?: boolean }>;
}

export const StickerSegmenter = registerPlugin<StickerSegmenterPlugin>('StickerSegmenter');
